import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { loadGiftsData } from "../../giftsApi";

// Route-effect component for "/gifts". Renders nothing - GiftsScreen.tsx
// (mounted unconditionally in AppRoot) owns the actual rendering into
// #giftsView, which this only shows/hides, same pattern as every other
// Phase 10 route screen.
export function GiftsRouteScreen() {
  useVisibleContainer("giftsView");

  useEffect(() => {
    loadGiftsData();
  }, []);

  return null;
}
